import { render, staticRenderFns } from "./TheTableDonatedFunds.vue?vue&type=template&id=25d025f4&scoped=true&"
import script from "./TheTableDonatedFunds.vue?vue&type=script&lang=ts&"
export * from "./TheTableDonatedFunds.vue?vue&type=script&lang=ts&"
import style0 from "./TheTableDonatedFunds.vue?vue&type=style&index=0&id=25d025f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d025f4",
  null
  
)

export default component.exports